export function useInitFeed(defaultFeedMode) {
    const getFeed = () => {
        const charts = window.Barchart.RealtimeWidgets.Charts;

        const feeds = {
            realtime: 'MarketDataFeed',
            eod: 'BarchartSiteDataFeed'
        };

        let feedMode = defaultFeedMode || 'eod';
        return charts[feeds[feedMode]];
    };

    const initFeed = () => {
        const charts = window.Barchart.RealtimeWidgets.Charts;

        let feedMode = defaultFeedMode || 'eod';

        const feed = charts.initFeed(getFeed(), {
            baseUrl: {
                timeseries: '/api/proxies/timeseries',
                ondemand: '/api/proxies/ondemand'
            },
            mode: 'GBE',
            showResizeHandles: true,
            // Override fetch method to include credentials
            async fetch(kind, relativeUrl) {
                const baseUrl = this.baseUrl[kind];
                const response = await fetch(`${baseUrl}${relativeUrl}`, {
                    credentials: 'include'
                });

                return await response.text();
            }
        });

        if (feedMode === 'realtime' ) {
            feed.connection = new charts.Connection();
            feed.connection.connect('wsqs-cf.aws.barchart.com', 'wwwcharts4www_rt', 'wwwcharts4wwwNew_rt');
        }

        return feed;
    };

    return {
        getFeed,
        initFeed,
    };
}
